import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  avatar: () => faker.internet.avatar(),
  fullName: () => faker.person.fullName(),
  phoneNumber: () => faker.phone.number(),
  createdAt: () => new Date(),
  email: () => faker.internet.email(),
  intercomIdentityHash: () => faker.lorem.word(),
  admin: false,
  password: null,
  newPassword: null,
  newPasswordConfirmation: null,
  pushEnabled: true,
  invitePushEnabled: true,
  hasProfile: true,
  privacyPolicyAcceptance: 'accepted',
  visitorsProductVideosEnabled: true,

  // Profile photo
  userPhotoUrl: null,
  userPhoto: undefined,

  withChangelog: trait({
    afterCreate(user, server) {
      server.createList('changelog', 3, 'locationSetting', { user });
    },
  }),

  withProfilePhoto: trait({
    userPhotoUrl: '/assets/images/high-five-v-01.png',
    userPhoto: 'high-five-v-01.png',
  }),

  withRealisticEmail: trait({
    email() {
      return faker.internet.email({
        firstName: this.fullName.split(' ')[0],
        lastName: this.fullName.split(' ').slice(1).join(' '),
      });
    },
  }),

  asEmployee: trait({
    afterCreate(user, server) {
      const location = server.schema.locations.first();
      server.create('employee', 'withEmployeeLocation', {
        user,
        locationIds: [location.id],
        name: user.fullName,
        email: user.email,
        hideFromEmployeeSchedule: user.hideFromEmployeeSchedule,
      });
    },
  }),

  asEmployeeWithExpiredDocument: trait({
    afterCreate(user, server) {
      const location = server.schema.locations.first();
      server.create('employee', 'withDeniedEmployeeLocation', {
        user,
        locationIds: [location.id],
        name: user.fullName,
        email: user.email,
      });
    },
  }),
});
